<template>
  <div>
    <vs-popup :active.sync="showDialog" title="Notificación">
      {{ text }}
      <div class="mt-6">
        <vs-button color="dark" class="mr-2" @click="_logout()">Cerrar sesión</vs-button>
        <vs-button @click="_refreshToken()">Aquí estoy</vs-button>
      </div>
    </vs-popup>

    <vs-popup
        title="Sesión finalizada"
        :active.sync="finishedDialogShow">
      Su sesión ha vencido, por favor inicie sesión nuevamente

      <div class="mt-6">
        <vs-button color="dark" @click="_logout()">Ir a Login</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import * as moment from "moment";
import {mapState, mapActions} from 'vuex';

export default {
  name: "TimerAccessToken2",
  props: {
    showDialogTimeout: {
      type: Number,
      default: 60
    }
  },
  computed: {
    ...mapState('auth', ['user', 'isLogged'])
  },
  data: () => ({
    finishedDialogShow: false,
    showDialog: false,
    intervalInstance: null,
    text: '',
    /** time manager */
    startDate: '',
    modalDate: '',
    endDate: ''

  }),
  watch: {
    user: function (val) {
      // if the value is null, the reason is the user close session
      if (val !== null) {
        // start session or refresh session
        clearInterval(this.intervalInstance)
        this.startCountDown(val.logged_at, this.user.expires_in);
      } else {
        // close session
        clearInterval(this.intervalInstance)
      }
    }
  },
  mounted() {
    if (this.isLogged) {
      clearInterval(this.intervalInstance)
      this.startCountDown(this.user.logged_at, this.user.expires_in);
    }

    this.$once('finishedTime', () => {
      this.showDialog = false;
      this.text = this.realTime;
      clearInterval(this.intervalInstance)
      this.finishedDialogShow = true;
      setTimeout(() => {
        document.querySelector(".md-dialog-overlay").style.background = "rgba(0,0,0,.95)"
      }, 500)
    })

    this.$on('finishingTime', (timeRemaining) => {
      this.text = `El tiempo de la sesion esta por terminar ${timeRemaining}`;
      this.showDialog = true;
    })
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('auth', ['refreshToken']),
    startCountDown(startTime, finishTime) {

      // 1. set start date session
      this.startDate = moment(startTime).unix()
      // 2. set modal show date session
      this.modalDate = moment(startTime).add((finishTime - this.showDialogTimeout), 's').unix()
      // 3. set finish date session
      this.finishTime = moment(startTime).add(finishTime, 's').unix()

      this.intervalInstance = setInterval(() => {
        let now = moment().unix()

        // this event fire when the session has expiring (before 60 seconds)
        if (this.modalDate <= now) {
          let nowDiff = moment.unix(now)
          let finishDiff = moment.unix(this.finishTime).diff(nowDiff, 's')

          this.$emit('finishingTime', finishDiff)
        }
        if (this.finishTime <= now) {
          this.$emit('finishedTime');
        }
      }, 1000)
    },
    async _logout(message) {
      try {
        await this.logout(message);
        this.showDialog = false;
        this.finishedDialogShow = false;
      } catch (e) {

      } finally {
        await this.$router.push(`/login?redirect=${this.$route.path}`);
      }
    },
    async _refreshToken() {
      await this.refreshToken(this.user.refresh_token);
      this.showDialog = false;
    },
  }
}
</script>

<style scoped>
.overlay-dark {
  background: rgba(0, 0, 0, .95);
}
</style>
